module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("g1Si1"))).then(() => parcelRequire('1iHdE'));